import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {CssService} from "../../../../services/css-service";

@Component({
  selector: 'app-rubric-item-list',
  templateUrl: './rubric-item-list.component.html',
  styleUrls: ['./rubric-item-list.component.css']
})
export class RubricItemListComponent implements OnInit {

  @Input() rub: any = null

  // Emmission à la méthode parente
  @Output() onRubricSelected = new EventEmitter<string>();

  constructor(
    public cssService: CssService) {

    // constructor
  }

  ngOnInit(): void {
    // ngOnInit
  }

  // Selection d'une rubrique
  onClickrubric(rubric: any) {
    // Rubrique sans enfants
    if (rubric.id_parent === 0 && rubric.childs.length === 0) {
      this.findRub(rubric);
    }
  }

  // Renvoi à la méthod parente
  findRub(rub: any): void {
    this.onRubricSelected.emit(rub);
  }
}
